import { alias, createModelSchema } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import {ProductTrackModel} from "@/modules/redactor/models/product/ProductTrackModel";

export class SmartOfferBundleTreasureShop extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.TREASURE_SHOP);
        this._track = null;
    }

    get track() {
        return this._track;
    }
    set track(value) {
        this._track = value;
    }
    valid() {

        if (!super.valid()) {
            return false;
        }
        if (!this.track || !this.track.valid()) {
            return false;
        }
        return true;
    }

    empty() {
        if (!this.track || this.track.empty()) {
            return true;
        }
        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTreasureShop());
        } else if (target instanceof SmartOfferBundleTreasureShop) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTreasureShop, {
    _track: alias("track", ProductTrackModel.schema())
});

